import {
  AssetProvider,
  AssetType,
  IAsset,
  IAssetDownload,
  Language,
  PublicationType,
} from '@imcc/transport';
import { PublicationSearchHitMetadata } from './publication-search-hit-metadata';

export class PublicationSearchHit implements IAsset {
  assetName: string;

  assetType: AssetType.Publication;

  downloadUrl: string;

  downloads: IAssetDownload[];

  editionYear: number;

  id: string;

  isReleased: boolean;

  language: Language;

  market: string;

  metadata: PublicationSearchHitMetadata;

  name: string;

  provider: AssetProvider.Internal;

  publicationType: PublicationType;

  relevanceScore: number;

  thumbnailUrl: string;

  previewUrl: string;

  fileExtension: 'pdf' = 'pdf';
}
